import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import AboutMe from "./AboutMe";
import Services from "./Services";
import Projects from "./Projects";
import Skills from "./Skills";
import Tools from "./Tools";
import Contact from "./Contact";


function App() {
  return (
   <div>
    <section id="header">
    <Header />
    </section>
    <section id="hero">
    <Hero />
    </section>
    <section id="about">
    <AboutMe />
    </section>
    <section id="services">
    <Services />
    </section>
    <section id="projects">
    <Projects />
    </section>
    <section id="skills">
    <Skills />
    </section>
    <section id="Tools">
    <Tools />
    </section>
    <section id="contact">
    <Contact />
    </section>
   </div>
  );
}

export default App;
